import { render, staticRenderFns } from "./industrialPark.vue?vue&type=template&id=21149a02&scoped=true&"
import script from "./industrialPark.vue?vue&type=script&lang=js&"
export * from "./industrialPark.vue?vue&type=script&lang=js&"
import style0 from "./industrialPark.vue?vue&type=style&index=0&id=21149a02&prod&scoped=true&lang=css&"
import style1 from "./industrialPark.vue?vue&type=style&index=1&id=21149a02&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21149a02",
  null
  
)

export default component.exports